import { render, staticRenderFns } from "./AdminForm.vue?vue&type=template&id=598929d2&"
import script from "./AdminForm.vue?vue&type=script&lang=ts&"
export * from "./AdminForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports